export enum Permission {
  unknown = 0,
  read = 1,
  manage = 2,
}
